import axios from 'axios';
import { X_API_Key } from 'utils';


export const createAPIEndPoint = (endpoint) => {
  const BASE_URL = process.env.REACT_APP_URL;
  // const X_API_Key = process.env.REACT_APP_X_API_Key;

  let token = typeof localStorage !== 'undefined' && localStorage.getItem('access_token');

  let url = `${BASE_URL}/${endpoint}`;
  return {
    fetchAll: () =>
      axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-API-Key': X_API_Key
        }
      }),
    create: (newRecord) =>
      axios.post(url, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-API-Key': X_API_Key, // Ensure this is correctly defined
        },
      }),

    fetchById: (id) =>
      axios.get(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-API-Key': X_API_Key
        }
      }),
    delete: (id) =>
      axios.delete(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-API-Key': X_API_Key
        }
      }),
    fetchFiltered: (params) =>
      axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-API-Key': X_API_Key
        },
        params
      }),

    update: (id, updatedRecord) =>
      axios.put(
        url + id,
        updatedRecord,
        token !== null && {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-API-Key': X_API_Key

          },
        }
      ),
    patchDashboard: (updatedRecord) =>
      axios.patch(
        url,
        updatedRecord,
        token !== null && {
          headers: {
            Authorization: `Bearer ${token}`,
            // 'Content-Type': 'application/json',
            'X-API-Key': X_API_Key,
          },
        }
      ),
    patch: () =>
      axios.patch(
        url + '/toggle',  // Assuming you're toggling something, modify this as needed
        {}, // Empty body or any necessary data, modify as needed
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'X-API-Key': X_API_Key
          },
        }
      ),

  };
};
